import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Link } from "react-router-dom"; // Предполагаем использование react-router-dom для ссылки
import { useTranslation, Trans } from "react-i18next";

interface ProcessingStartDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (dontShowAgain: boolean) => void;
  sourceFilename: string;
  targetDocumentType: string;
}

export function ProcessingStartDialog({
  open,
  onOpenChange,
  onConfirm,
  sourceFilename,
  targetDocumentType,
}: ProcessingStartDialogProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm(dontShowAgain);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('common.processing_started_title')}</DialogTitle>
          <DialogDescription>
            <Trans
              i18nKey="common.processing_started_description"
              values={{ source: sourceFilename, target: targetDocumentType }}
              components={{ 1: <span className="font-semibold" />, 3: <span className="font-semibold" /> }}
            />
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-gray-500 mb-4">
            {t('common.processing_note')}
          </p>
          <div className="flex items-center space-x-2 mb-4">
            <Checkbox
              id="dont-show-again"
              checked={dontShowAgain}
              onCheckedChange={(checked: boolean) => setDontShowAgain(checked)}
            />
            <Label
              htmlFor="dont-show-again"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {t('common.dont_show_again')}
            </Label>
          </div>
          <Link to="/profile" className="text-sm text-blue-500 hover:underline">
            {t('common.go_to_notification_settings')}
          </Link>
        </div>
        <DialogFooter>
          <Button type="button" onClick={handleConfirm}>
            {t('common.ok')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
